module.exports = __webpack_public_path__ + "static/media/close_ffffff.8e3533c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/close_ffffff.svg
// module id = 132
// module chunks = 51